import React, { Component } from "react";
import dayjs from "dayjs";
import DOMPurify from "dompurify";
import { MessageType } from "./Message";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import Retry from "./RetryMessage";
import { s360ConfigService } from "../../Services/S360Config";
import { quotedPreviewOf } from "./quotePreview";
import styled from "styled-components";

const SentMessageWithTail = styled.div`
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: -8px;
    width: 12px;
    height: 12px;
    background: ${props => props.$bgColor || 'white'};
    clip-path: polygon(0 0, 100% 0, 0 100%);
  }
`;
const ReceivedMessageWithHead = styled.div`
  overflow: visible !important;
  &::before {
    top: ${props => props.$top || '0px'};
    background: ${props => props.$bgColor || 'white'};
  }
`;

class TextMessage extends Component {
  state = { hovered: false };
  isLink(string) {
    if (
      (!isNullOrUndefined(string) && string?.includes("https://")) ||
      string?.includes("http://")
    ) {
      return true;
    } else {
      return false;
    }
  }
  extractLinkFunction = (message) => {
    if (message?.includes("href")) {
      message.match(/\bhttps?:\/\/\S+/gi);
      if (
        message.match(/"([^"]*)"/)[0].length >= 2 &&
        message.match(/"([^"]*)"/)[0].charAt(0) == '"' &&
        message
          .match(/"([^"]*)"/)[0]
          .charAt(message.match(/"([^"]*)"/)[0].length - 1) == '"'
      ) {
        message = message
          .match(/"([^"]*)"/)[0]
          .substring(1, message.match(/"([^"]*)"/)[0].length - 1);
      }

      return message;
    } else return message;
  };

  showMessageTime = () => {
    return this.props.message.type !== MessageType.info;
  };

  messageTimeClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      case MessageType.info:
        return "s360-message-time-info";
      default:
        return "";
    }
  };

  messageBoxClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return "s360-message-box-received";
      case MessageType.info:
        return this.props.convoType === "TRANSFER"
          ? "s360-message-box-info-agent"
          : "s360-message-box-info";
      default:
        return "";
    }
  };

  messageContainerClassName = () => {
    const tailClass = s360ConfigService.config.designDetails?.showMessageTailTriangle ? " s360-message-tail" : "";
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent" + tailClass;
      case MessageType.received:
        return (s360ConfigService.config.autoFullScreen
          ? "s360-message-cotainer-received-fs"
          : "s360-message-cotainer-received") + tailClass;
      case MessageType.info:
        return "s360-message-cotainer-info";
      default:
        return "";
    }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    switch (this.props.message.type) {
      case MessageType.sent:
        let sentStyle = {
          background: config.designDetails.recieverMessageColor,
          fontFamily: config.designDetails.ReceiverMessageFont,
          fontSize: config.designDetails.ReceiverMessageFontSize,
          color: config.designDetails.recieverMessageFontColor,
          padding: config.designDetails.paddingText,
          fontWeight: config.designDetails.senderFontWeight || 500,

        };
        if (!!config.designDetails?.showOutgoingMessageTimeInside) {
          sentStyle['flexDirection'] = 'column';
        }
        if (!!config.designDetails?.showMessageTailTriangle) {
          sentStyle['marginRight'] = '20px';
        }
        if (!isNullOrUndefined(config.designDetails?.cardBorderRadius)) {
          sentStyle['borderRadius'] = `${config.designDetails.cardBorderRadius}px`;
          if (!!config.designDetails?.showMessageTailTriangle) {
            sentStyle['borderTopRightRadius'] = '0px';
          } else {
            sentStyle['borderBottomRightRadius'] = '0px';
          }
        }

        return sentStyle
      case MessageType.received:
        const styles = {
          background: config.designDetails.senderMessageColor,
          fontFamily: config.designDetails.SenderMessageFont,
          fontSize: config.designDetails.SenderMessageFontSize,
          color: config.designDetails.senderMessageFontColor,
        };
        if (config.designDetails?.hideCardBoxShadow) {
          styles.boxShadow = 'none';
          styles.border = "1px solid"
          styles.borderColor = isNullOrUndefined(config.designDetails?.buttonBorderColor)
                ? "#0092ed"
                : config.designDetails.buttonBorderColor;
        }
        return styles;
      case MessageType.info:
        let infoStyle = {
          fontFamily: config.designDetails.ReceiverMessageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageFontColor,
        };
        if (!isNullOrUndefined(config.designDetails?.conversationTimeStampBackgroundColor)) {
          infoStyle['backgroundColor'] = config.designDetails.conversationTimeStampBackgroundColor;
          infoStyle['color'] = 'black'
        }
        return infoStyle;
      default:
        return {};
    }
  };
  emojiStyle = () => {
    let config = this.props.config;
    switch (this.props.message.type) {
      case MessageType.received:
        return {
          background: config.designDetails.senderMessageColor,
          fontFamily: config.designDetails.SenderMessageFont,
          fontSize: config.designDetails.SenderMessageFontSize,
          color: config.designDetails.senderMessageFontColor,
        };
      case MessageType.sent:
        return {
          background: "white",
          fontFamily: config.designDetails.ReceiverMessageFont,
          fontSize: config.designDetails.ReceiverMessageFontSize,
          color: config.designDetails.recieverMessageFontColor,
          padding: config.designDetails.paddingText,
        };
      case MessageType.info:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageFontColor,
        };
      default:
        return {};
    }
  };

  messageContainerStyle = () => {
    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    switch (this.props.message.type) {
      case MessageType.received:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
          textAlign: config.designDetails.incomingMessageTextAlign || 'left',
          marginRight: '0',
        };
      case MessageType.sent:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails?.showOutgoingMessageTimeInside ? "white" : config.designDetails.messageTimeFontColor,
        };
      case MessageType.info:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      default:
        return {};
    }
  };

  formattedVideLinkbasedOnConfig = (text, creator, isAgentLinkWrapped) => {
    console.log(s360ConfigService?.config?.agentWrapLinkDomains);
    const urlRegex =  /(https?:\/\/[^\s]+|ftp:\/\/[^\s]+|www\.[^\s]+)/g;
    const urls = [...new Set(text.match(urlRegex) || [])];
    const getDomain = (url) => {
      try {
        return new URL(url).origin; 
      } catch {
        return ""; 
      }
    };
    
    const textDomain = getDomain(text);
    const parts = text.split(urlRegex);
    if (creator === "AGENT") {
      if (isAgentLinkWrapped && s360ConfigService.config.agentWrapLinkDomains) {
        if (
          text.includes("/3rd/roomVideo")
        ) {
          return (
            <div
              className={this.messageBoxClassName()}
              style={this.messageBoxStyle()}
            >
              <span>
                Please{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={this.extractLinkFunction(
                    this?.props?.message?.message?.text
                  )}
                >
                  click here
                </a>{" "}
                to start the Video Call.
              </span>
              <br />
            </div>
          );
        } else {
          return (
            <div
              className={this.messageBoxClassName()}
              style={this.messageBoxStyle()}
            >
              {parts.map((part, index) => {
        if (urls.includes(part)) {
          return (
            <a
              key={index}
              href={part.startsWith("www.") ? `http://${part}` : part}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue", textDecoration: "underline" }}
            >
              {part}
            </a>
          );
        }
        // If it's not a URL, render it as plain text
        return <span key={index}>{part}</span>;
      })}
              <br />
            </div>
          );
        }
      } else if (isAgentLinkWrapped) {
       if( text.includes("/3rd/roomVideo")){ return (
          <div
            className={this.messageBoxClassName()}
            style={this.messageBoxStyle()}
          >
            <span>
              Please{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={this.extractLinkFunction(
                  this?.props?.message?.message?.text
                )}
              >
                click here
              </a>{" "}
              to start the Video Call.
            </span>
            <br />
          </div>
        );}
     
          else {
            return (
              <div
                className={this.messageBoxClassName()}
                style={this.messageBoxStyle()}
              >
                {parts.map((part, index) => {
          if (urls.includes(part)) {
            return (
              <a
                key={index}
                href={part.startsWith("www.") ? `http://${part}` : part}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "blue", textDecoration: "underline" }}
              >
                {part}
              </a>
            );
          }
          // If it's not a URL, render it as plain text
          return <span key={index}>{part}</span>;
        })}
                <br />
              </div>
            );
          }
        
      }
      else if(parts && parts.length>0){
        return (
          <div
            className={this.messageBoxClassName()}
            style={this.messageBoxStyle()}
          >
            {parts.map((part, index) => {
      if (urls.includes(part)) {
        return (
          <a
            key={index}
            href={part.startsWith("www.") ? `http://${part}` : part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            {part}
          </a>
        );
      }
      // If it's not a URL, render it as plain text
      return <span key={index}>{part}</span>;
    })}
            <br />
          </div>
        );
      }
    } 
    else if (creator === "CUSTOMER") {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "end",
            justifyContent: "center",
          }}
        >
          <div
            className={this.messageBoxClassName()}
            style={this.messageBoxStyle()}
          >
            {text}
          </div>
        </div>
      );
    } 
    else if(parts && parts.length>0){
      return (
        <div
          className={this.messageBoxClassName()}
          style={this.messageBoxStyle()}
        >
          {parts.map((part, index) => {
    if (urls.includes(part)) {
      return (
        <a
          key={index}
          href={part.startsWith("www.") ? `http://${part}` : part}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "blue", textDecoration: "underline" }}
        >
          {part}
        </a>
      );
    }
    // If it's not a URL, render it as plain text
    return <span key={index}>{part}</span>;
  })}
          <br />
        </div>
      );
    }
    else {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "end",
            justifyContent: "center",
          }}
        >
          <div
            className={this.messageBoxClassName()}
            style={this.messageBoxStyle()}
            dangerouslySetInnerHTML={{
              __html: text?.replace(/\n/g, "<br/>"),
            }}
          >
            {/* <br /> */}
          </div>
        </div>
      );
    }
  };

  renderMessageFooter = (styles = {}) => {
    return (
      <div style={styles}>
        {this.showMessageTime() && (
          <div
            className={this.messageTimeClassName()}
            style={this.messageTimeStyle()}
          >
            {dayjs
              .unix(Math.trunc(this?.props?.message?.message?.sentTimestamp / 1000))
              .format(s360ConfigService.config.designDetails?.messageTimeStampFormat || "DD MMM hh:mm a")}
          </div>
        )}
        <Retry {...this.props} />
      </div>
    )
  }

  render() {
    const { message } = this.props;
    console.log("textt msgg", message);
    // text to render
    let text = this.props.message?.message?.text || "";
    
    if(!text) 
      return null;

    // sanitize text before rendering
    text = DOMPurify.sanitize(text);
    text = text.replace(/\n/g, "<br/>");
    if (message?.message?.hide) {
      text = text.replace(/[^\s]/g, '*');
    }

    const quotedText = this.props.message?.message?.quotedText || this.props.message?.quotedText;
    const quotedMsgId = this.props.message?.message?.quotedMsgId;
    const sentTimestamp = this.props.message?.message?.sentTimestamp;
    const messageId = this.props.message?.message?.messageId;
    const canReply = typeof this.props.onReplyToMessage === "function"
      && this.props.message?.type !== MessageType.info
      && this.props.message?.message?.text;
    // Resolve the quoted parent by its stable messageId (fallback: sentTimestamp for legacy quotes).
    const resolvedQuoted = quotedMsgId
      ? (this.props.messages || []).find((m) =>
          String(m?.message?.messageId) === String(quotedMsgId) ||
          String(m?.message?.sentTimestamp) === String(quotedMsgId))
      : null;
    const quotedSnippet = quotedPreviewOf(resolvedQuoted, quotedText);
    const scrollToQuoted = () => {
      if (!quotedMsgId) return;
      const sel = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(String(quotedMsgId)) : String(quotedMsgId);
      const node = document.querySelector(`[data-s360-msg-id="${sel}"]`)
        || document.querySelector(`[data-s360-msg-ts="${sel}"]`);
      if (!node) return;
      node.scrollIntoView({ behavior: "smooth", block: "center" });
      const prev = node.style.backgroundColor;
      node.style.transition = "background-color 0.3s";
      node.style.backgroundColor = "rgba(0,95,236,0.12)";
      setTimeout(() => { node.style.backgroundColor = prev; }, 1200);
    };

    const bubble = (
      this.isLink(this.props.message?.message?.text) ? (
          this.formattedVideLinkbasedOnConfig(
            this.props.message?.message?.text,
            this.props.message?.creator,
            s360ConfigService.config?.wrapAgentLinks
          )
        ) : s360ConfigService.config.designDetails?.showMessageTailTriangle 
            && this.props.message.type === MessageType.sent 
            ? (
              <SentMessageWithTail
                $bgColor={this.props.config.designDetails.recieverMessageColor}
                className={this.messageBoxClassName()}
                style={this.messageBoxStyle()}
              >
                <div dangerouslySetInnerHTML={{ __html: text }} />
                {s360ConfigService.config.designDetails?.showOutgoingMessageTimeInside 
                  && this.renderMessageFooter({ display: "flex", alignItems: "center", justifyContent: "flex-end" })}
              </SentMessageWithTail>
            )
          : s360ConfigService.config.designDetails?.showMessageTailTriangle
            && this.props.message.type === MessageType.received
            ? (
              <ReceivedMessageWithHead
                $bgColor={s360ConfigService.config.designDetails?.senderMessageColor || 'white'}
                $top={s360ConfigService.config.designDetails?.hideCardBoxShadow ? '-1px !important' : '0px'}
                className={this.messageBoxClassName()}
                style={this.messageBoxStyle()}
              >
                <div dangerouslySetInnerHTML={{ __html: text }} />
                {s360ConfigService.config.designDetails?.showOutgoingMessageTimeInside 
                  && this.renderMessageFooter({ display: "flex", alignItems: "center", justifyContent: "flex-end" })}
              </ReceivedMessageWithHead>
            )
          : (
              <div
                className={this.messageBoxClassName()}
                style={this.messageBoxStyle()}
              >
                <div dangerouslySetInnerHTML={{ __html: text }} />
                {s360ConfigService.config.designDetails?.showOutgoingMessageTimeInside && this.renderMessageFooter({ display: "flex", alignItems: "center", justifyContent: "flex-end" })}
              </div>
          )
    );
    const footer = !s360ConfigService.config.designDetails?.showOutgoingMessageTimeInside
      && this.renderMessageFooter({ display: "flex", alignItems: "center", marginRight: 7 });

    const quoteLayout = !!s360ConfigService?.config?.configDetails?.enableQuoteReply
      && this.props.message?.type !== MessageType.info;
    if (!quoteLayout) {
      return (
        <div
          className={this.messageContainerClassName()}
          style={this.messageContainerStyle()}
        >
          {bubble}
          {footer}
        </div>
      );
    }

    const isSent = this.props.message.type === MessageType.sent;
    const showReply = this.state.hovered || (typeof window !== "undefined" && "ontouchstart" in window);
    // Line the quote up with the bubble's own horizontal margins (style.css .s360-message-box-*).
    const bubbleSideMargins = isSent
      ? { marginLeft: 20, marginRight: s360ConfigService.config.designDetails?.showMessageTailTriangle ? 20 : 8 }
      : { marginLeft: 20, marginRight: 11 };

    return (
      <div
        className={this.messageContainerClassName()}
        style={{ ...this.messageContainerStyle(), position: "relative" }}
        data-s360-msg-id={messageId != null ? String(messageId) : undefined}
        data-s360-msg-ts={sentTimestamp != null ? String(sentTimestamp) : undefined}
        onMouseEnter={() => this.setState({ hovered: true })}
        onMouseLeave={() => this.setState({ hovered: false })}
      >
        {/* Column so the quoted preview always stacks above its bubble (received rows are flex-row + wrap). */}
        <div
          style={{
            display: "flex", flexDirection: "column", width: "100%", minWidth: 0,
            alignItems: isSent ? "flex-end" : "flex-start",
          }}
        >
          {(quotedSnippet || quotedMsgId) && (
            <div
              className="s360-quoted-message"
              onClick={quotedMsgId ? scrollToQuoted : undefined}
              style={{
                ...bubbleSideMargins,
                marginTop: 4, marginBottom: 0,
                borderLeft: "3px solid #005fec", background: "rgba(0,95,236,0.06)",
                padding: "4px 8px", borderRadius: 4,
                fontSize: "0.85em", color: "#55596b",
                maxWidth: "calc(100% - 40px)", boxSizing: "border-box",
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                cursor: quotedMsgId ? "pointer" : "default",
              }}
            >
              {quotedSnippet || "View quoted message"}
            </div>
          )}
          {/* Reply affordance on the bubble's inner edge: trails received bubbles, leads sent ones. */}
          <div
            style={{
              // Full width so the bubble's percentage max-width resolves against the row as before.
              display: "flex", alignItems: "center", width: "100%", minWidth: 0,
              flexDirection: isSent ? "row-reverse" : "row",
            }}
          >
            {bubble}
            {/* Space is always reserved (visibility toggles) so the bubble doesn't reflow on hover. */}
            {canReply && (
              <span
                role="button"
                aria-label="reply"
                title="Reply"
                aria-hidden={!showReply}
                onClick={() => this.props.onReplyToMessage(this.props.message)}
                style={{
                  visibility: showReply ? "visible" : "hidden", margin: "0 4px",
                  flexShrink: 0, cursor: "pointer", fontSize: 13, lineHeight: 1,
                  color: "#005fec", background: "#fff", border: "1px solid #005fec",
                  borderRadius: "50%", width: 24, height: 24,
                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                }}
              >
                ↩
              </span>
            )}
          </div>
        </div>
        {footer}
      </div>
    );
  }
}

export default TextMessage;
